export default __webpack_public_path__ + "static/media/6_fooddiary__january.57f6b550.jpg";